/** Skip link WCAG 2.4.1 — visível apenas ao receber foco via teclado. */
export const MAIN_CONTENT_ID = 'synap-main-content'

const skipLinkClassName =
  'sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-[calc(env(safe-area-inset-top,0px)+3.5rem)] focus:z-[100] focus:rounded-xl focus:border focus:border-[var(--color-border)] focus:bg-[var(--color-bg-surface)] focus:px-4 focus:py-2.5 focus:text-sm focus:font-semibold focus:text-[var(--color-text-primary)] focus:shadow-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-mint-ring)]'

interface SkipToContentLinkProps {
  /** Rótulo em pt-BR; default salta para `#synap-main-content`. */
  label?: string
  /** Destino alternativo (ex.: `#plantoes-hours-by-location`). */
  href?: string
}

export const SkipToContentLink = ({
  label = 'Ir para o conteúdo principal',
  href = `#${MAIN_CONTENT_ID}`,
}: SkipToContentLinkProps) => (
  <a href={href} className={skipLinkClassName}>
    {label}
  </a>
)
